var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "sas-dashboard-container",
    },
    [
      _c(
        "div",
        {
          ref: "chart3",
          staticClass: "section-chart-container-3",
          attrs: { id: "chart3" },
        },
        [
          _c("div", { staticClass: "chart3-egs" }, [
            _c("div", { staticClass: "eg-item" }, [
              _c("div", {
                ref: "egGreen",
                staticClass: "eg-color eg-color-green",
              }),
              _c("div", { staticClass: "eg-text" }, [
                _vm._v(_vm._s(_vm.$t("sas_dashboard_examples_14"))),
              ]),
            ]),
            _c("div", { staticClass: "eg-item" }, [
              _c("div", {
                ref: "egGray",
                staticClass: "eg-color eg-color-gray",
              }),
              _c("div", { staticClass: "eg-text" }, [
                _vm._v(_vm._s(_vm.$t("sas_dashboard_examples_23"))),
              ]),
            ]),
          ]),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.tableData,
                "cell-style": _vm.chart3CellStyle,
                "row-style": { height: "44px" },
                "max-height": "320",
                fit: true,
              },
            },
            [
              _c("el-table-column", {
                attrs: { fixed: "", width: "150", "show-overflow-tooltip": "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", {
                          staticClass: "chart3-entity-name-inner",
                          domProps: { innerHTML: _vm._s(scope.row.entityName) },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c(
                "el-table-column",
                { attrs: { label: _vm.chart3Level1Label, align: "center" } },
                _vm._l(_vm.chart3Level2Columns, function (v, k) {
                  return _c("el-table-column", {
                    key: k,
                    attrs: { "column-key": v.id, label: v.milestoneName },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: { placement: "top", effect: "light" },
                                },
                                [
                                  _c("div", {
                                    attrs: { slot: "content" },
                                    domProps: {
                                      innerHTML: _vm._s(v.milestoneName),
                                    },
                                    slot: "content",
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "chart3-header-outer" },
                                    [
                                      _c("span", {
                                        staticClass: "chart3-header-inner",
                                        domProps: {
                                          innerHTML: _vm._s(v.milestoneName),
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }